import { z } from "zod";

export const partnerActivationSchema = z.object({
	agentId: z
		.string()
		.min(1, "Agent ID is required")
		.transform((s) => s.trim()),
	mainOfficeId: z
		.string()
		.min(1, "Main Office ID is required")
		.transform((s) => s.trim()),
});

export type PartnerActivationFormData = z.infer<typeof partnerActivationSchema>;
